import { MetadataEntitiesClient, MetadataEntityCreateRequest, MetadataEntityResponse, MetadataEntityType } from "@api/apiClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "@api/axiosInstance";

const client = new MetadataEntitiesClient(undefined, axios);

const MODEL_FAMILY_TYPE = "ModelFamily";

/** Model Family only: list for settings grid. */
export const useModelFamilyMaterials = (options?: any) => {
  return useQuery({
    ...options,
    queryKey: ["modelFamily", MODEL_FAMILY_TYPE],
    initialData: [],
    queryFn: async () => client.getMetaDataByType(MODEL_FAMILY_TYPE),
  });
};

/** Model Family only: add a new entity. */
export const useAddModelFamilyMaterial = (options?: any) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: ({ value }: { value: string }) => {
      const createRequest = new MetadataEntityCreateRequest({
        name: value,
        type: MODEL_FAMILY_TYPE,
      });
      return client.createMetaDataEntity(createRequest);
    },
    onSuccess: (...args: unknown[]) => {
      queryClient.invalidateQueries({ queryKey: ["modelFamily", MODEL_FAMILY_TYPE] });
      options?.onSuccess?.(...args);
    },
  });
};

/** Model Family only: delete by id. */
export const useDeleteModelFamilyMaterial = (options?: any) => {
  const queryClient = useQueryClient();
  const { onSuccess: callerOnSuccess, ...rest } = options ?? {};
  return useMutation<boolean, unknown, { id: string }>({
    ...rest,
    mutationFn: ({ id }) => client.deleteMetaDataEntitybyId(id),
    onSuccess: (...args: unknown[]) => {
      queryClient.invalidateQueries({ queryKey: ["modelFamily", MODEL_FAMILY_TYPE] });
      callerOnSuccess?.(...args);
    },
  });
};

/** Model Family only: add multiple family types under a parent. */
export const useAddNonModelledFamilyType = (options?: any) => {
  return useMutation<MetadataEntityResponse[], unknown, { ModelFamilyId: string; ModelFamilyTypeList: string[] }>({
    ...options,
    mutationFn: async ({ ModelFamilyId, ModelFamilyTypeList }) => {
      const createRequests = ModelFamilyTypeList.map((familyType) =>
        new MetadataEntityCreateRequest({
          name: familyType,
          parentId: ModelFamilyId,
          type: MetadataEntityType.ModelFamilyType,
        })
      );
      return client.createModelFamilyTypeEntity(createRequests);
    },
  });
}
